import React from 'react';
import { Button } from './ui/button';
export function AboutTrust() {
  return <section className="py-20 md:py-32 bg-charcoal text-white" data-id="element-15">
      <div className="container mx-auto px-4 md:px-6" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-17">
          {/* Image Column */}
          <div className="relative" data-id="element-18">
            <div className="aspect-[3/4] md:aspect-[4/5] overflow-hidden rounded-sm" data-id="element-19">
              <img src="https://cdn.magicpatterns.com/uploads/5L17MyCX76giQUrW9p7Wka/One-Percent-Listing-AZ-Scottsdale-Arizona-Home-Seller-Flat-Fee-One-Percent.webp" alt="One Percent Listing AZ Scottsdale Arizona home" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-20" />
            </div>
            {/* Decorative Offset Frame */}
            <div className="absolute -bottom-6 -left-6 w-full h-full border border-gold/30 z-0 hidden md:block rounded-sm pointer-events-none" data-id="element-21" />
          </div>

          {/* Content Column */}
          <div className="relative z-10" data-id="element-22">
            <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-23">
              About One Percent Listing AZ
            </p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-6" data-id="element-24">
              Brokered by AZ Dream Homes. Built for the modern seller.
            </h2>
            <p className="text-white/70 text-lg mb-10 leading-relaxed" data-id="element-25">
              We're a licensed Arizona real estate team that refuses to believe
              great service requires inflated commissions. Powered by the full
              brokerage support of AZ Dream Homes, our listing agents combine
              deep local market knowledge with modern technology and lean
              operations. The result: luxury-level service at a fraction of the
              cost.
            </p>

            {/* Trust Stats */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-0 justify-between items-start sm:items-center py-8 border-y border-gold/20 mb-10" data-id="element-26">
              <div className="flex-1 text-center sm:text-left" data-id="element-27">
                <span className="block font-serif text-xl text-gold mb-1" data-id="element-28">
                  Licensed
                </span>
                <span className="text-xs text-white/60 uppercase tracking-wider" data-id="element-29">
                  AZ Real Estate
                </span>
              </div>
              <div className="hidden sm:block w-[1px] h-12 bg-gold/20 mx-4" data-id="element-30" />
              <div className="flex-1 text-center" data-id="element-31">
                <span className="block font-serif text-xl text-gold mb-1" data-id="element-32">
                  Full Service
                </span>
                <span className="text-xs text-white/60 uppercase tracking-wider" data-id="element-33">
                  No discount service
                </span>
              </div>
              <div className="hidden sm:block w-[1px] h-12 bg-gold/20 mx-4" data-id="element-34" />
              <div className="flex-1 text-center sm:text-right" data-id="element-35">
                <span className="block font-serif text-xl text-gold mb-1" data-id="element-36">
                  100%
                </span>
                <span className="text-xs text-white/60 uppercase tracking-wider" data-id="element-37">
                  Commitment to sellers
                </span>
              </div>
            </div>

            <Button variant="outline" className="border-white text-white hover:bg-white hover:text-charcoal bg-transparent h-12 px-8 text-base w-full sm:w-auto" data-id="element-38">
              Meet the Team
            </Button>
          </div>
        </div>
      </div>
    </section>;
}